import {
  SAVE_PROGRAM_START,
  SAVE_PROGRAM_SUCCESS,
  SAVE_PROGRAM_ERROR,
  DELETE_PROGRAM_START,
  DELETE_PROGRAM_SUCCESS,
  DELETE_PROGRAM_ERROR,
} from '../constants';
import fetchErrorHandler from '../services/fetchErrorHandler';
import { getCsrfToken } from '../utils/helpers';

export const saveProgram = (directoryProgram, schoolId, saved, savedProgramId) => async (
  dispatch,
  getState,
  { fetch },
) => {
  const { apiVersion } = getState().runtime;
  const { applicationId } = getState().user;
  const { locale } = getState().intl;
  const data = {
    directory_program: directoryProgram,
    application: applicationId,
    guardian: getState().user.guardianId,
  };

  const urlParameters = Object.entries(data)
    .map(e => `${encodeURIComponent(e[0])}=${encodeURIComponent(e[1])}`)
    .join('&');
  if (!saved) {
    dispatch({ type: SAVE_PROGRAM_START });

    return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/saved-programs/`, {
      credentials: 'include',
      headers: {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-CSRFToken': getCsrfToken(),
      },
      method: 'POST',
      body: urlParameters,
    })
      .then(fetchErrorHandler)
      .then(resp => resp.json())
      .then(respData => {
        dispatch({
          type: SAVE_PROGRAM_SUCCESS,
          payload: { applicationId, id: directoryProgram, schoolId, respData },
        });
        return 'FAVORITE_SUCCESS';
      })
      .catch(error => {
        dispatch({
          type: SAVE_PROGRAM_ERROR,
          payload: {
            error,
          },
        });
        return 'FAVORITE_ERROR';
      });
  }
  dispatch({ type: DELETE_PROGRAM_START });

  return fetch(`${locale}/api/${apiVersion}/application/${applicationId}/saved-programs/${savedProgramId}`, {
    credentials: 'include',
    headers: {
      'X-CSRFToken': getCsrfToken(),
    },
    method: 'DELETE',
  })
    .then(fetchErrorHandler)
    .then(resp => {
      dispatch({
        type: DELETE_PROGRAM_SUCCESS,
        payload: { id: directoryProgram, application: applicationId, schoolId },
      });
      return 'UNFAVORITE_SUCCESS';
    })
    .catch(error => {
      dispatch({
        type: DELETE_PROGRAM_ERROR,
        payload: {
          error,
        },
      });
      return 'UNFAVORITE_ERROR';
    });
};
